__turbopack_context__.v({
  "close": "AdaptiveSpotlight-module__-tR3pa__close",
  "conf": "AdaptiveSpotlight-module__-tR3pa__conf",
  "link": "AdaptiveSpotlight-module__-tR3pa__link",
  "spot-in": "AdaptiveSpotlight-module__-tR3pa__spot-in",
  "spotlight": "AdaptiveSpotlight-module__-tR3pa__spotlight",
  "text": "AdaptiveSpotlight-module__-tR3pa__text",
});
